import { DateTime } from 'luxon';

/**
 * Receives a date object (optional), a type string (optional), and returns a formatted
 * date string based on the following types:
 *
 * - datetime: 2020-12-31T09:00:00-0300  (default type)
 * - date: 2020-12-31
 * - time: 09:00:00-0300
 * @param {Date} currentDate
 * @param {String} type
 */
export const getFormattedDate = (
  currentDate = new Date(),
  type = 'datetime'
) => {
  const date = DateTime.fromJSDate(currentDate);
  const timeZone = getTimeZoneFormatted();

  switch (type) {
    case 'date':
      return date.toFormat(`yyyy-MM-dd`);
    case 'time':
      return date.toFormat(`HH:mm:ss${timeZone}`);
    default:
      return date.toFormat(`yyyy-MM-dd'T'HH:mm:ss${timeZone}`);
  }
};

export const isDateTimeOrDatetimeValid = (stringInput) => {
  // new Date().getTime() generates as timestamp number of 13 characters
  // so an input of less than 13 characters is not the right format to be a timestamp
  // without this check it might happen that an input's value is considered as a date timestamp and goes through this removeTimeZoneFormatted step
  let stringifiedInputValue = '' + stringInput;
  if(stringifiedInputValue.length < 13) return false;

  if(stringInput && stringInput !== ''){
    return DateTime.fromISO(stringInput).isValid
  }
  if(stringInput.match(/^\d{2}\:\d{2}\:\d{2}(\+|\-)\d{4}$/)){
    return true
  }
  return false
}

export const removeTimeZoneFormatted = (dateString) => {
  let finalDate = '';
            
  if (dateString.split(':').length > 2 && dateString.split('-').length === 0) {
    if (dateString.includes('-')) {
      let b = dateString.split('-');
      finalDate = b[0];
    } else if (dateString.includes('+')) {
      let b = dateString.split('+');
      finalDate = b[0];
    } else {
      finalDate = dateString
    }
  } else {
    if (dateString.split('+').length > 1) {
      let b = dateString.split('+');
      finalDate = b[0];
    } else {
      let b = dateString.split('-');
      if (b.length > 3) {
        b.pop();
        finalDate = b.join('-');

      } else {
        finalDate = dateString
      }
    }
  }
  return finalDate;
}

/**
 * Shall return "-0400" (EDT)
 */
const getTimeZoneFormatted = () => {
  return DateTime.now().toFormat(`ZZZ`);
};

export default getTimeZoneFormatted;
